import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { Context } from "../..";
import styles from './RegistrationForm.module.scss';

type FormValues = {
  email: string;
  password: string;
};

const RegistrationForm: React.FC = () => {
  const { store } = React.useContext(Context);
  const { register, handleSubmit, formState: { errors }, setError } = useForm<FormValues>();
  const navigate = useNavigate();

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    if (!data.password || data.password.length < 8 || !/[A-Z]/.test(data.password) || !/[a-z]/.test(data.password) || !/[0-9]/.test(data.password)) {
      if (data.password.length < 8) {
        setError('password', { type: 'manual', message: 'Пароль повинен бути не менше 8 символів' });
      } else if (!/[A-Z]/.test(data.password)) {
        setError('password', { type: 'manual', message: 'Пароль повинен містити хоча б одну велику літеру' });
      } else if (!/[a-z]/.test(data.password)) {
        setError('password', { type: 'manual', message: 'Пароль повинен містити хоча б одну маленьку літеру' });
      } else if (!/[0-9]/.test(data.password)) {
        setError('password', { type: 'manual', message: 'Пароль повинен містити хоча б одну цифру' });
      }
      return;
    }

    const response = await store.registration(data.email, data.password);
    if (response?.status === 200) {
      navigate(store.redirectPath || '/');
    } else {
      alert(response?.data?.message || 'Помилка реєстрації');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles['form__block']}>
      <fieldset className={styles['form__field']}>
        <label htmlFor="email" className={styles['form__label']}>Електронна пошта:</label>
        <input
          type="email"
          id="email"
          className={styles['form__input']}
          {...register('email', { required: 'Це поле обов`язкове' })}
        />
        {errors.email && <p className={styles['error-message']}>{errors.email.message}</p>}
      </fieldset>

      <fieldset className={styles['form__field']}>
        <label htmlFor="password" className={styles['form__label']}>Пароль:</label>
        <input
          type="password"
          id="password"
          className={styles['form__input']}
          {...register('password', { required: 'Це поле обов`язкове' })}
        />
        {errors.password && <p className={styles['error-message']}>{errors.password.message}</p>}
      </fieldset>

      <button type="submit" className={styles['form__submit']}>Зареєструватися</button>
    </form>
  );
};

export default observer(RegistrationForm);
